import React from 'react';
import motorIcono from '../../../../img/ficha/motor.svg';
import confIcono from '../../../../img/ficha/configuracion.png';
import frenosIcono from '../../../../img/ficha/frenos.png';
import equiIcono from '../../../../img/ficha/equipamiento.png';
import chasisIcono from '../../../../img/ficha/chasis.png';
import transmisionIcono from '../../../../img/ficha/transmision.png';
import { Col, Row, Carousel } from 'react-bootstrap';
import { Tabs } from 'antd';

import './secciones.css'
import useWindowDimensions from '../../../../hooks/Front/windowDimentions/useDimentions';
import { Sticky, StickyContainer } from 'react-sticky';


const { TabPane } = Tabs;

const Especificaciones = ({ especificaciones }) => {

    const { width } = useWindowDimensions();


    let margen = width <= 767 ? "130px" : width <= 991 ? "260px" : "198px"
    let heightResp = width >= 767 && width <= 1440 ? "70px" : "80px"

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky topOffset={-90}>
            {({ style, isSticky }) => (
                <DefaultTabBar {...props} style={{ ...style, zIndex: 100, height: heightResp, top: isSticky ? margen : '0px' }} />
            )}
        </Sticky>
    );

    if (!especificaciones || especificaciones.length < 1) return null;
    return (
        <StickyContainer >
            <Tabs className="tab-vehiculo" id="tab-especificacion" centered renderTabBar={renderTabBar}>
                {especificaciones && especificaciones.length > 0 &&
                    especificaciones.map((especificacion) =>
                        <TabPane tab={<h5 className="parrafo-hyundai f-18 color-mobile px-tabs-especificacion mt-3 mb-2">{especificacion.Nombre}</h5>} key={especificacion.Nombre}>
                            <Especificacion data={especificacion} />
                        </TabPane>
                    )
                }
            </Tabs>
        </StickyContainer>
    );
};


const Especificacion = ({ data }) => {

    if (!data) return null;

    let iconoMostrar;
    // console.log("especificacion", data);

    switch (data.Nombre) {
        case "Motor":
            iconoMostrar = motorIcono;
            break;
        case "Configuración":
            iconoMostrar = confIcono;
            break;
        case "Transmisión":
            iconoMostrar = transmisionIcono;
            break;
        case "Frenos":
            iconoMostrar = frenosIcono;
            break;
        case "Chasis":
            iconoMostrar = chasisIcono;
            break;
        case "Equipamiento":
            iconoMostrar = equiIcono;
            break;

        default:
            break;
    }
    return (
        <>
            <Row className="d-none d-md-flex">
                <Col xs={6} className="my-5">
                    <Carousel className="carousel-primario">
                        { data.Imagenes && data.Imagenes.length > 0 && data.Imagenes.map( (imagen, index) =>
                            <Carousel.Item key={index}>
                                <img src={imagen.Imagen} alt={data.Nombre} className="img-fluid img-especificaciones mx-3" style={{ maxWidth: '100%'}} />
                            </Carousel.Item>
                        )}
                    </Carousel>
                </Col>
                <Col xs={6} className="my-auto px-4">
                    <Row>
                        <Col md={11} lg={10} xl={9} className="px-5 mx-auto">
                            { iconoMostrar && <img src={iconoMostrar} alt={data.Nombre} className="img-fluid mb-5" /> }
                            <h5 className="bold-title-hyundai">{data.Nombre}</h5>
                            <p className="parrafo-hyundai f-ev" dangerouslySetInnerHTML={{ __html: data.Descripcion }}></p>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="d-md-none mt-4">
                <Col xs={12} className="text-center">
                    { iconoMostrar && <img src={iconoMostrar} alt={data.Nombre} className="img-fluid mb-3 mt-2" width="40px" /> }
                    <h5 className="bold-title-hyundai f-responsive-12 mx-4">{data.Nombre}</h5>
                    <p className="parrafo-hyundai text-left px-5 p-mobile f-responsive-10" dangerouslySetInnerHTML={{ __html: data.Descripcion }}></p>
                </Col>
                <Col xs={12} className="my-3">
                    <Carousel className="carousel-primario">
                        { data.Imagenes && data.Imagenes.length > 0 && data.Imagenes.map( (imagen, index) =>
                            <Carousel.Item key={index}>
                                <img src={imagen.Imagen} alt={data.Nombre} className="img-fluid img-especificaciones" />
                            </Carousel.Item>
                        )}
                    </Carousel>
                </Col>
            </Row>
        </>
    )
}

export default Especificaciones;